// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Form = function Form(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.438 2.5H15c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5a2.5 2.5 0 0 1-2.5-2.5V5c0-1.379 1.121-2.5 2.5-2.5h1.938a3.126 3.126 0 0 1 6.125 0zM5 4.375A.627.627 0 0 0 4.375 5v12.5c0 .344.281.625.625.625h10a.627.627 0 0 0 .625-.625V5A.627.627 0 0 0 15 4.375h-.625v.938c0 .519-.418.937-.937.937H6.563a.935.935 0 0 1-.938-.937v-.938zm5-.312a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874"
  }));
};
